import Layout from "./components/templates/layouts/Layout";

function App() {
  return (
    <div>
      <Layout />
    </div>
  );
}

export default App;
